var uriTemplates = require('uri-templates');
var ts = require('../lib/util.es6').ts;

var FileWrapper = Backbone.Model.extend({
    initialize: function (data, options) {
        options = options || {};
        this.session = options.session;
        this.localFile = options.localFile;
    },
    triggerBubble: function () {
        var args = _.toArray(arguments);
        this.trigger.apply(this, args);
        var event = args.shift();
        args.unshift(event, this);
        this.session.trigger.apply(this.session, args);
    },
    isPreviewable: function () {
        return this.isPreviewableImage() && this.isPreviewableSize();
    },
    isOwn: function () {
        return !!this.get('own_file');
    },
    isImage: function () {
        return FileWrapper.isImage(this.getType());
    },
    isVideo: function () {
        return FileWrapper.isVideo(this.getType());
    },
    isAudio: function () {
        return FileWrapper.isAudio(this.getType());
    },
    isMedia: function () {
        return FileWrapper.isMedia(this.getType());
    },
    isPreviewableImage: function () {
        return FileWrapper.isPreviewableImage(this.getType());
    },
    isPreviewableMedia: function () {
        return FileWrapper.isPreviewableMedia(this.getType());
    },
    isPreviewableSize: function () {
        return FileWrapper.isPreviewableSize(this.get('size'));
    },
    isTooLarge: function () {
        return FileWrapper.isTooLarge(this.get('size'));
    },
    isText: function () {
        return FileWrapper.isText(this.getType());
    },
    getName: function () {
        return this.get('name');
    },
    getUrl: function () {
        return uriTemplates(this.getTemplateUri()).fill(this.getTemplateUriParams());
    },
    isWidthAboveThreshold: function (width) {
        var fileWidth = this.getWidth();
        return !fileWidth || (fileWidth / width) > 1.1;
    },
    getResizedUrl: function (dimensions) {
        if (dimensions && dimensions.width && this.isWidthAboveThreshold(dimensions.width)) {
            var quantiseWindow = 100;
            var quantised = Math.ceil(dimensions.width/quantiseWindow)*quantiseWindow;
            return this.getWidthUrl(quantised);
        }
        return this.getUrl();
    },
    getWidthUrl: function (width) {
        return this.getTemplateUrl('w' + width);
    },
    getSquareUrl: function (width) {
        return this.getTemplateUrl('s' + width);
    },
    getTemplateUri: function () {
        return window.IRCConfig.file_uri_template;
    },
    getBaseTemplateUriParams: function () {
        return {
            id: this.id
        };
    },
    getTemplateUriParams: function () {
        var params = this.getBaseTemplateUriParams();
        params.name = this.get('name');
        return params;
    },
    getTemplateUrl: function (modifier) {
        var params = this.getBaseTemplateUriParams();
        params.modifiers = modifier;
        return uriTemplates(this.getTemplateUri()).fill(params);
    },
    cacheDataUrl: function (dataUrl) {
        FileWrapper.cacheDataUrl(this.id, dataUrl);
    },
    uncacheDataUrl: function () {
        FileWrapper.uncacheDataUrl(this.id);
    },
    getCachedUrl: function (dimensions) {
        return FileWrapper.cachedDataUrl(this.id) || this.getResizedUrl(dimensions);
    },
    desiredName: function () {
        return this.desiredFilename || this.getName();
    },
    dummyUrl: function () {
        var name = this.desiredName();
        if (FileWrapper.nameToExtension(name) != this.get('extension')) {
            name += this.get('extension');
        }
        return uriTemplates(this.getTemplateUri()).fill({
            id: this.id || '...',
            name: name
        });
    },
    getJSONUrl: function () {
        return this.session.backend.buildRawUrl('/file/json/' + this.id);
    },
    getType: function () {
        return this.get('mime_type');
    },
    getSize: function () {
        return FileWrapper.sizeToString(this.get('size'));
    },
    getDate: function () {
        return new Date(this.get('date') * 1000);
    },
    getExtension: function () {
        return this.get('extension').replace(/^\./, '');
    },
    getProp: function (key) {
        var props = this.get('properties');
        if (props) {
            return props[key];
        }
    },
    getWidth: function () {
        return this.get('width') || (this.getProp('width') - 0);
    },
    getHeight: function () {
        return this.get('height') || (this.getProp('height') - 0);
    },
    isDeleted: function () {
        return !!this.get('deleted');
    },
    isErrored: function () {
        return !!this.get('errored');
    },
    fetch: function () {
        var url = this.getJSONUrl();
        if (!url) {
            return $.Deferred().reject().promise();
        }
        return this.session.ajax({
            url: url,
            dataType: 'json',
            xhrFields: { // for CORS xhr cookie transport
                withCredentials: true
            }
        }, function (response) {
            return !!response.id;
        }, function (request) {
            return request.status != 404;
        }).done(_.bind(function (response, statusText, request) {
            this.uploaded = true;
            if (statusText == 404) {
                this.set('deleted', true);
            } else {
                this.set(response);
            }
        }, this)).fail(_.bind(function (request, errorString, errorThrown) {
            this.set('errored', true);
        }, this));
    },
    setUploadId: function () {
        if (!this.uploadId) {
            this.uploadId = FileWrapper._UPLOAD_IDS++;
        }
    },
    getUploadId: function () {
        return this.uploadId;
    },
    uploadPath: function () {
        return this.session.backend.buildRawUrl(FileWrapper.UPLOAD_PATH);
    },
    upload: function () {
        this.setUploadId();
        this.triggerBubble('uploadStart');
        var complete = new $.Deferred();
        var formData = new window.FormData();
        formData.append('file', this.localFile);
        var promise = this.session.ajax({
            url: this.uploadPath(),
            type: 'post',
            data: formData,
            dataType: 'json',
            headers: {
                'x-irccloud-session': this.session.getAuthCookie()
            },
            xhrFields: { // for CORS xhr cookie transport
                withCredentials: true
            },
            // Options to tell jQuery not to process data or worry about content-type.
            contentType: false,
            processData: false
        }, function (response) {
            return !!response;
        });

        this.bind('cancelUpload', function () {
            if (promise.state() == 'pending') {
                promise.ajax.abort();
            } else {
                complete.reject('cancel');
                this.triggerBubble('uploadCancelled');
            }
        });
        promise.done(_.bind(function (response, status, jqXHR) {
            this.set('id', response.id);
            complete.resolve(response);
        }, this));
        promise.progress(_.bind(function (type, evt) {
            if (type == 'upload' && evt.lengthComputable) {
                var percentComplete = Math.round(evt.loaded * 100 / evt.total);
                complete.notify(evt, percentComplete);
                this.triggerBubble('uploadProgress', evt, percentComplete);
            } else {
                // Always triggered once for download phase
                // enters non-deteministic finalising state
                complete.notify();
                this.triggerBubble('uploadFinalise');
            }
        }, this));
        promise.fail(_.bind(function (jqXHR, errorString, response) {
            this.uploadErrorType = errorString;
            this.uploadError = response;
            if (errorString == 'abort') {
                complete.reject('cancel', response);
                this.triggerBubble('uploadCancelled');
            } else {
                complete.reject('error', response);
                this.triggerBubble('uploadError');
            }
        }, this));
        return complete.promise();
    },
    getError: function () {
        return this.finaliseError || this.uploadError;
    },
    cancelUpload: function () {
        this.trigger('cancelUpload');
    },
    finaliseParams: function () {
        return {
            id: this.id,
            filename: this.desiredName(),
            original_filename: this.localFile.name
        };
    },
    finalise: function (options, callback) {
        return this.session.post('upload-finalise', this.finaliseParams(), _.bind(function (response) {
            if (response.success) {
                var cachedWidth = this.getWidth();
                var cachedHeight = this.getHeight();
                this.set(response.file);
                this.uploaded = true;
                this.triggerBubble('uploadSuccess'); // results in dataURL getting cached
                // Check whether we should immediately uncache it
                if (
                    cachedWidth != this.getWidth() ||
                    cachedHeight != this.getHeight()
                ) {
                    // Dimensions changed, probably orientation corrected
                    // discard cached data
                    this.uncacheDataUrl();
                }
            } else {
                this.finaliseError = response || true;
                this.triggerBubble('uploadError');
            }
            if (callback) {
                callback(response);
            }
        }, this));
    },
    setReqId: function (buffer, reqid) {
        this.sentToBuffer = buffer;
        this.reqid = reqid;
        this.sentToBuffer.messages.bind('add', this.setSentMessage, this);
    },
    setSentMessage: function (message) {
        if (message.get('reqid') == this.reqid) {
            this.sentMessage = message;
            if (!this.isUploaded()) {
                // Failed upload within a batch
                this.sentToBuffer.trigger('addErrorUpload', this, this.uploadErrorType, this.getError());
            }
            this.sentToBuffer.messages.unbind('add', this.setSentMessage, this);
        }
    },
    showMessage: function () {
        if (this.sentToBuffer) {
            this.sentToBuffer.select();
            if (this.sentMessage) {
                if (this.sentMessage.show()) {
                    return true;
                }
            }
            if (this.reqid) {
                this.sentToBuffer.trigger('showPending', this.reqid);
                return true;
            }
        }
        return false;
    },
    isUploaded: function () {
        return !!this.uploaded;
    },
    post: function (method, data, callback) {
        data.file = this.id;
        return this.session.post(method, data, callback);
    },
    edit: function (data, callback) {
        return this.post('edit-file', data, _.bind(function (response) {
            if (response.success) {
                this.set(response.file);
            }
            if (callback) {
                callback(response);
            }
        }, this));
    },
    remove: function (callback) {
        return this.post('delete-file', {}, _.bind(function (response) {
            if (response.success) {
                this.set('deleted', true);
            }
            if (callback) {
                callback(response);
            }
        }, this));
    },
    restore: function (callback) {
        return this.post('restore-file', {}, _.bind(function (response) {
            if (response.success) {
                this.set('deleted', false);
            }
            if (callback) {
                callback(response);
            }
        }, this));
    }
}, {
    _UPLOAD_IDS: 1,
    KB: 1000,
    MB: 1000 * 1000,
    MAX_LENGTH_BYTES: 15728640,
    MAX_UPLOAD_BATCH: 10,
    DATA_URL_CACHE: {},
    CAN_PLAY_CACHE: {},
    FILE_BLACKLIST: {
        '.DS_Store': true
    },
    UPLOAD_PATH: '/chat/upload',
    sizeToString: function (size) {
        var fileSize = 0;
        if (size > FileWrapper.MB) {
            fileSize = (Math.round(size * 100 / FileWrapper.MB) / 100).toString() + 'MB';
        } else {
            fileSize = (Math.round(size * 100 / FileWrapper.KB) / 100).toString() + 'KB';
        }
        return fileSize;
    },
    cacheDataUrl: function (id, dataUrl) {
        FileWrapper.DATA_URL_CACHE[id] = dataUrl;
    },
    uncacheDataUrl: function (id) {
        delete FileWrapper.DATA_URL_CACHE[id];
    },
    cachedDataUrl: function (id) {
        return FileWrapper.DATA_URL_CACHE[id];
    },
    nameToExtension: function (name) {
        var match = name.match(/(\.[^.]+)$/);
        return match ? match[1] : '';
    },
    isPreviewableSize: function (size) {
        return size < (5 * FileWrapper.MB);
    },
    isTooLarge: function (size) {
        return size > FileWrapper.MAX_LENGTH_BYTES;
    },
    isPreviewableImage: function (type) {
        return type === 'image/png'
            || type === 'image/gif'
            || type === 'image/jpeg'
            || type === 'image/webp';
    },
    isPreviewableMedia: function (type) {
        if (type in FileWrapper.CAN_PLAY_CACHE) {
            return FileWrapper.CAN_PLAY_CACHE[type];
        } else {
            if (FileWrapper.isMedia(type)) {
                var canPlay = false;
                var v = document.createElement('video');
                if (v.canPlayType && v.canPlayType(type).replace(/no/, '')) {
                    canPlay = true;
                }
                FileWrapper.CAN_PLAY_CACHE[type] = canPlay;
                return canPlay;
            } else {
                return false;
            }
        }
    },
    isImage: function (type) {
        return !!type.match(/^image\//i);
    },
    isVideo: function (type) {
        return !!type.match(/^video\//i)
            || type === 'application/ogg';
    },
    isAudio: function (type) {
        return !!type.match(/^audio\//i);
    },
    isMedia: function (type) {
        return FileWrapper.isVideo(type) || FileWrapper.isAudio(type);
    },
    isText: function (type) {
        return !!type.match(/^text\//i)
            || type === 'application/atom+xml'
            || type === 'application/ecmascript'
            || type === 'application/javascript'
            || type === 'application/json'
            || type === 'application/rdf+xml'
            || type === 'application/rss+xml'
            || type === 'application/xhtml+xml'
            || type === 'application/xml';
    },
    fromFile: function (file, session, type) {
        var name = file.name || '';
        type = type || FileWrapper;
        return new type({
            name: name,
            extension: FileWrapper.nameToExtension(name),
            mime_type: file.type,
            size: file.size,
            date: Math.round(ts()/1000),
            own_file: true
        }, {
            session: session,
            localFile: file
        });
    },
    // Based on http://stackoverflow.com/questions/4998908/convert-data-uri-to-file-then-append-to-formdata/15754051#15754051
    detectDataURI: function (text) {
        return text.match(/data:([^;]+);base64,([a-z0-9+\/]+=*)/im);
    },
    blobFromDataURI: function (dataURI) {
        // convert base64/URLEncoded data component to raw
        // binary data held in a string
        if (!dataURI) {
            return;
        }
        var uriMatch = dataURI.match(/^data:([^;]+);base64,([a-z0-9+\/]+=*)$/i);
        if (!uriMatch) {
            return;
        }
        var mimeString = uriMatch[1];
        var data = uriMatch[2];
        var byteString;
        try {
            byteString = atob(data);
        } catch (exc) {
            // Invalid data
            return;
        }

        // write the bytes of the string to a typed array
        var ab = new window.ArrayBuffer(byteString.length);
        var ia = new window.Uint8Array(ab);
        for (var i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
        }

        var blob = new Blob([ia], {type:mimeString});
        if (!blob.size) {
            return;
        }

        return blob;
    },
    getEntries: function (dt) {
        if (dt.items && dt.items[0]) {
            if (dt.items[0].webkitGetAsEntry) {
                return _.filter(_.map(dt.items, function (item) {
                    return item.webkitGetAsEntry();
                }), _.identity);
            }
        }
    },
    traverseFileTree: function (entry, complete, currentDir) {
        currentDir = currentDir || complete.tree;
        if (entry.isFile) {
            // Get file
            if (FileWrapper.FILE_BLACKLIST[entry.name]) {
                complete.notify('done', 1);
            } else {
                entry.file(function(file) {
                    currentDir.push(file);
                    complete.notify('addFile');
                    complete.notify('done', 1);
                });
            }
        } else if (entry.isDirectory) {
            // Get folder contents
            var newCurrentDir = [];
            currentDir.push({
                dir: entry.name,
                children: newCurrentDir
            });
            var dirReader = entry.createReader();
            FileWrapper.readDirEntries(dirReader, newCurrentDir, complete);
        }
    },
    readDirEntries: function (dirReader, newCurrentDir, complete) {
        dirReader.readEntries(function (entries) {
            if (complete.state() != 'pending') {
                return;
            }
            if (entries.length) {
                complete.notify('add', entries.length);
                _.each(entries, function (dirEntry) {
                    if (complete.state() != 'pending') {
                        return;
                    }
                    FileWrapper.traverseFileTree(dirEntry, complete, newCurrentDir);
                });
                FileWrapper.readDirEntries(dirReader, newCurrentDir, complete);
            } else {
                complete.notify('done', 1);
            }
        });
    },
    flattenTree: function (tree, flattened) {
        flattened = flattened || [];
        if (tree.length) {
            _.each(tree, function (node) {
                if (node.dir) {
                    flattened = flattened.concat(FileWrapper.flattenTree(node.children, flattened));
                } else if (!FileWrapper.isTooLarge(node.size)) {
                    flattened.push(node);
                }
            });
        }
        return flattened;
    },
    collectFileTree: function (entries, files) {
        var processCount = 0;
        var fileCount = 0;
        var complete = new $.Deferred();
        complete.tree = [];
        complete.progress(function (event, amount) {
            switch (event) {
            case 'add':
                processCount += amount;
                break;
            case 'done':
                processCount -= amount;
                break;
            case 'addFile':
                fileCount++;
                break;
            }
            if (fileCount > FileWrapper.MAX_UPLOAD_BATCH) {
                return complete.resolve(complete.tree, true);
            }
            if (!processCount) {
                return complete.resolve(complete.tree);
            }
        });
        if (entries) {
            complete.notify('add', entries.length);
            _.each(entries, function (entry) {
                FileWrapper.traverseFileTree(entry, complete);
            });
        } else if (files) {
            files = _.filter(files, function (file) {
                return file.size > 0;
            });
            complete.resolve(files);
        } else {
            complete.reject();
        }
        return complete.promise();
    }
});

module.exports = FileWrapper;



//////////////////
// WEBPACK FOOTER
// ./app/src/model/filewrapper.js
// module id = JHsc
// module chunks = 1